
define('text!app/../../views/map.html',[],function () { return '<div class="mapWrapper">\t\n\t<div class="map" id="map">\n\t</div>\n    <div class="content">\n        <div class="blurb">\n            <h1><%=H1%></h1>\n            <div><%=BLURB1%></div>\n        </div>\n    </div>\n</div>';});

